import React from 'react';

import { useTypedSelector } from 'store';

const TokenFeeHead: React.FC = () => {
  const dexPair = useTypedSelector(store => store.pairs.selectedDexPair)!;

  return <div style={{ textAlign: 'left' }}>{dexPair.token_fee.symbol}</div>;
};

export { TokenFeeHead };
